module.exports = {"5b75912c19279aabe8b1897a":"English","5b75912c19279aabe8b189cb":"English (USA)","5b75912c19279aabe8b1899e":"Brasil","5b75912c19279aabe8b18a28":"Russia","5b75912c19279aabe8b189e0":"Portugal","5b75912c19279aabe8b189d4":"Germany","5b75912c19279aabe8b1895c":"Spain","5b75912c19279aabe8b189ad":"México","5b75912c19279aabe8b189b0":"Argentina","5b75912c19279aabe8b18977":"Colombia","5b75912c19279aabe8b18997":"Latin America","5b75912c19279aabe8b18a53":"Indonesia","5b75912c19279aabe8b18968":"Italia","5b75912c19279aabe8b18971":"France","5b75912c19279aabe8b189bc":"Arabic"}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./config/editions.json
// module id = 187
// module chunks = 2